"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ifRtl;

var _propsEvalOrReturn = _interopRequireDefault(require("./propsEvalOrReturn"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ifRtl(truthyValue, falseyValue) {
  return function (props) {
    var isThemeRtl = props && props.theme && props.theme.isRtl || false;
    if (isThemeRtl) return (0, _propsEvalOrReturn["default"])(truthyValue, props);
    return (0, _propsEvalOrReturn["default"])(falseyValue, props);
  };
}